import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../hook/redux";

function QRCodeButton(  ) {
  const qrCode = useAppSelector((state) => state.editor.qrCode);

  const dispatch = useAppDispatch();

    /**
   * Toggles the state of the QR code feature in the editor.
   * @param value - A boolean indicating whether the QR code feature should be enabled or disabled.
   */
    const toggleQrCode = (value: boolean) => {
      dispatch({
        type: "editor/toggleQrCode",
        payload: value,
      });
    };

  return (
      <div className="toolbar-button"
           onClick={ () => {toggleQrCode(!qrCode);} }
           data-test={"layout-qrcode"}>
        <i className="fas fa-qrcode"></i>
      </div>
      );
      }
      export default QRCodeButton;